module.exports = __webpack_public_path__ + "img/discover-dark_x2.b34040d5.svg";